const binding = { modules: {}, dataActions: {} };

    (binding.modules['ecomm-page-title'] = {
        c: () => require('partner/modules/ecomm-page-title/ecomm-page-title.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'ecomm-page-title',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/ecomm-page-title'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|ecomm-page-title|ecomm-page-title'] = {
                c: () => require('partner/modules/ecomm-page-title/ecomm-page-title.view.tsx'),
                cn: '__local__-__local__-ecomm-page-title'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };